var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableLayout",staticClass:"table-layout overflow-hidden"},[(_vm.$slots['search-bar'])?_c('div',{ref:"searchWrapper",staticClass:"search-bar",class:_vm.searchBarClass},[_vm._t("search-bar")],2):_vm._e(),_c('div',{ref:"tableWrapper",staticClass:"table-wrapper",class:_vm.tableWrapperClass},[_vm._t("table")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }